<template>
    <div class="print-table-bottom">
        <div>制表：{{userName}}</div>
        <div>
            <div>技术部确认：</div>
            <div >日期：</div>
        </div>    
        <div>
            <div>设计部确认：</div>
            <div>日期：</div>
        </div> 
    </div>
</template>

<script>
export default {
    name: 'table-bottom',
    props: {
        userName: {
            type: String
        }
    },
    methods: {
        
    },
    data() {
        return {
        }
    }
}
</script>